import { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { StoresContext } from '../../../provider/StoreProvider'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { Button } from '../../../components/button'
import { Footer } from '../../../components/footer'
import { Header } from '../../../components/header'
import { PagingContent } from '../../../components/pagingList'
import { Text, StyledText } from '../../../components/text'
import { RowBetween, List, Item } from '../../../components/common'
import { DivideLineBold } from '../../../components/divide'

export const Qna = observer(() => {
  const { commonStore, myStore } = useContext(StoresContext)
  const pagingStore = myStore.qnaPagingStore

  useEffect(() => {
    commonStore.setShowTab(false)
    pagingStore.load(undefined, true)
  }, [])

  return (
    <Wrap>
      <Header type="SUB" title="1:1문의" />
      <Content>
        <QnaInfoWrap>
          <Text size={18} weight={600} block={true}>
            운영시간 안내
          </Text>
          <QnaTime size={14} lineHeight={22} color="error" block={true}>
            접수시간: 24시간접수
            <br />
            답변 가능 시간: 월-금 10:00 ~ 17:00
          </QnaTime>
          <Text size={12} color="text_secondary" block={true}>
            답변 가능 시간 이후 접수건은 운영시간 내 순차적으로 답변해 드려요.
          </Text>
        </QnaInfoWrap>
        <DivideLineBold />
        <PagingContent pagingStore={pagingStore}>
          <List>
            {pagingStore.list.map(({ id, title, createdDate, status }) => (
              <Link key={id} to={`/qna/${id}`}>
                <Item gap={12}>
                  <RowBetween>
                    {status === 'WAIT_FOR_REPLY' ? (
                      <Text size={12} weight={500} color="error">
                        답변 대기
                      </Text>
                    ) : (
                      <Text size={12} weight={500} color="primary_5">
                        답변 완료
                      </Text>
                    )}
                    <Text size={12} color="text_secondary">
                      {dayjs(new Date(createdDate)).format('YYYY.MM.DD')}
                    </Text>
                  </RowBetween>
                  <Text size={16} weight={500}>
                    {title ?? '-'}
                  </Text>
                </Item>
              </Link>
            ))}
          </List>
        </PagingContent>
      </Content>
      <Footer>
        <Button type="primary" size="large" block={true} href="/qna/register">
          문의하기
        </Button>
      </Footer>
    </Wrap>
  )
})

const QnaInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 24px 16px;
  font-size: 13px;
`

const QnaTime = styled(StyledText)`
  margin: 16px 0 24px;
`
